import PropTypes from 'prop-types'
import { Element } from '../../../../../common/html/element'
import classes from './index.module.scss'

export const NotificationMsg = ({ className, style, text, render }) => {
  return (
    <Element
      className={[className, classes.container].join(' ')}
      style={{
        borderLeftWidth: 3,
        borderLeftStyle: 'solid',
        borderLeftColor: '#0553a5',
        backgroundColor: '#edf5fe',
        marginBottom: 12,
        ...style,
      }}
    >
      <Element
        style={{
          color: '#3a414b',
        }}
        className={classes.notiContent}
      >
        {render ? render() : text}
      </Element>
    </Element>
  )
}

NotificationMsg.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  text: PropTypes.string.isRequired,
  render: PropTypes.func,
}

NotificationMsg.defaultProps = {
  className: '',
  style: {},
  text: '',
}
